if($(".tiposocioPedirNumsocioNifTicket").length) {
    $(document).on('click',"#mostrarEscojerDias .btn",function(){
        $("#reserves-container").removeClass('hidden');
    });

    $("#escojer_tiporecursoPedirNumsocioNifTicket .btn").click(function(){
        window.location.href = "/reserves/cal_week.php?resource="+$(this).data('id_mst_tiporecurso')+"&date="+$('#escojer_tiporecursoPedirNumsocioNifTicket [name=date]').val()+"&showReservesContainer=1";
    });
}

$(function(){
    if ($('.front').hasClass('cal_week_autoreload')) {
        //Comprobem les noves reserves cada 2 minuts

        var reservas_usuario_setmana = JSON.parse($("[name=reservas_usuario_setmana]").val());

        var CAL_WEEK_AUTORELOAD_TIME_miliseconds = $('[name=CAL_WEEK_AUTORELOAD_TIME_miliseconds]').val();
        var CAL_WEEK_COMPROBAR_CAMBIO_DIA_miliseconds = $('[name=CAL_WEEK_COMPROBAR_CAMBIO_DIA_miliseconds]').val();

        

        setInterval(function () {
            reservas_usuario(reservas_usuario_setmana,0,$("[name=reservas_usuario_tipus_recurs]").val());
        }, CAL_WEEK_AUTORELOAD_TIME_miliseconds); //Temps 2 minuts (120000ms)

        //Comprobem cada 5 minuts si ha canviat de dia
        var date = moment.utc(reservas_usuario_setmana[0],'YYYY/MM/DD H:m:s');
        setInterval(function () {
            axios.get('/api/comprobar_cambio_dia',{params:{
                    dia:date.format('YYYY/MM/DD HH:mm:ss')
                }}).then(function(res){
                if (parseInt(res.data.status)==1){
                    location.reload(true);
                }
            });
        }, CAL_WEEK_COMPROBAR_CAMBIO_DIA_miliseconds); //Temps 5 minuts (300000ms)
    }
});